import { render, staticRenderFns } from "./AdicionarJogador.vue?vue&type=template&id=52c758b4&scoped=true"
import script from "./AdicionarJogador.vue?vue&type=script&lang=js"
export * from "./AdicionarJogador.vue?vue&type=script&lang=js"
import style0 from "./AdicionarJogador.vue?vue&type=style&index=0&id=52c758b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c758b4",
  null
  
)

export default component.exports